import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { Logo } from "./Header";

const LINKS = [
  { to: "/shop", label: "Shop" },
  { to: "/contact", label: "Contact" },
  { to: "/policies/shipping", label: "Shipping Policy" },
  { to: "/policies/returns", label: "Return Policy" },
  { to: "/policies/privacy", label: "Privacy Policy" },
  { to: "/policies/terms", label: "Terms of Service" },
];

export default function Footer() {
  const { settings } = useStore();
  return (
    <footer className="border-t border-white/10 mt-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-[1.5fr_1fr_1fr]">
        <div>
          <Logo className="text-white text-lg" />
          <p className="mt-4 text-sm text-zinc-500 max-w-xs">NOT YOUR AVERAGE PRINT.</p>
          <div className="flex gap-4 mt-6">
            {settings?.instagram && (
              <a href={settings.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="text-zinc-400 hover:text-white transition-colors">
                <Instagram size={18} />
              </a>
            )}
            {settings?.tiktok && (
              <a href={settings.tiktok} target="_blank" rel="noreferrer" data-testid="footer-tiktok" className="text-zinc-400 hover:text-white text-xs tracking-widest uppercase transition-colors">
                TikTok
              </a>
            )}
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <span className="eyebrow mb-2">Shop</span>
          {LINKS.slice(0, 2).map((l) => (
            <Link key={l.to} to={l.to} className="text-sm text-zinc-400 hover:text-white transition-colors" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}>{l.label}</Link>
          ))}
        </div>
        <div className="flex flex-col gap-3">
          <span className="eyebrow mb-2">Info</span>
          {LINKS.slice(2).map((l) => (
            <Link key={l.to} to={l.to} className="text-sm text-zinc-400 hover:text-white transition-colors" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}>{l.label}</Link>
          ))}
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 text-[11px] text-zinc-600 tracking-widest uppercase font-mono-ui">
          © 2026 SPICY3D WORLD
        </div>
      </div>
    </footer>
  );
}
